import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'
import InputTextAreaSF from '../../../../widgets/form/InputTextAreaSF'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'
import './RepaymentRemarksModal.css'

const DsraEventListModalUI = ({ context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted, status,
    // event handlers
    onSubmit, onCancelClick,
    // fields
    eventDate, onEventDateChange, eventDateError, setEventDateError,
    dsraTotal, onDsraTotalChange, dsraTotalError, setDsraTotalError,
    dsraCurrent, onDsraCurrentChange, dsraCurrentError, setDsraCurrentError
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Add remarks'
        buttonLabel='Save'
        cancelLabel='Cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >

        <InputDateUI context={context} name='date' label='Event date'
            selectedDateISO={eventDate} onChange={onEventDateChange}
            error={eventDateError} setError={setEventDateError}
        />

        <InputTextSF type='text' name='dsraTotal' maxLength={12}
            label='DSRA total'
            value={dsraTotal} onChange={onDsraTotalChange}
            error={dsraTotalError} setError={setDsraTotalError}
        />

        <InputTextSF type='text' name='dsraCurrent' maxLength={12}
            label='DSRA current'
            value={dsraCurrent} onChange={onDsraCurrentChange}
            error={dsraCurrentError} setError={setDsraCurrentError}
        />

    </ModalFormUI>

export default DsraEventListModalUI
